import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';
import {CampaignProvider} from "./context/CampaignContext";

const CampaignFragment = Loadable(lazy(() => import('./list/CampaignFragment')));
const AddCampaign = Loadable(lazy(() => import('./add')));
const PreviewCampaign = Loadable(lazy(() => import('./preview')));
const EditCampaign = Loadable(lazy(() => import('./edit')));

const campaignsRoutes = [
    { path: '/campaign/list', element: <CampaignProvider><CampaignFragment /></CampaignProvider>, auth: authRoles.admin },
    { path: '/campaign/add', element: <CampaignProvider><AddCampaign  /></CampaignProvider>, auth: authRoles.admin },
    { path: '/campaign/preview/:id', element: <CampaignProvider><PreviewCampaign /></CampaignProvider>, auth: authRoles.admin },
    { path: '/campaign/edit/:id', element: <CampaignProvider><EditCampaign /></CampaignProvider>, auth: authRoles.admin }
];

export default campaignsRoutes;
